import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var SignalCellularAlt2Bar = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 14h3v6H5v-6zm6-5h3v11h-3V9z"
  }));
});
SignalCellularAlt2Bar.displayName = 'SignalCellularAlt2Bar';
export var SignalCellularAlt2BarDimensions = {
  height: 24,
  width: 24
};